import { optionTitle_displayBy } from './strings.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let DisplayByOption: LazyOption = createLazyOption(
    {
        key: 'displayBy',
        titleStringKey: optionTitle_displayBy,
        searchTermsStringKey: optionTitle_displayBy,
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default DisplayByOption;
